import { render } from "./CSVDownloadView.vue?vue&type=template&id=70905922"
import script from "./CSVDownloadView.vue?vue&type=script&lang=js"
export * from "./CSVDownloadView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__